module.exports = __webpack_public_path__ + "static/media/shape1_3.75b0d464.obj";